export default "__VITE_ASSET__BBtnmYut__"